const removeDuplicates = (array = []) =>
  array.filter((arr, i) => array.indexOf(arr) === i);

function formatCpf(unformatedCpf) {
  let cpf = String(unformatedCpf).replace(/\.|-/g, '');
  if (cpf.length < 11) {
    for (let i = cpf.length; i < 11; i += 1) {
      cpf = `0${cpf}`;
    }
  }
  return cpf;
}

function parseDateToExcelDate(parseDate) {
  if (!parseDate) return '';

  const date = new Date(parseDate);
  return `${date.getDate()}/${date.getUTCMonth() + 1}/${date.getFullYear()}`;
}

module.exports = {
  removeDuplicates,
  formatCpf,
  parseDateToExcelDate
};
